import React, { createContext, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import eventTypes from "../data/event_types.json";

const EventTypeContext = createContext({});

export const EventTypeProvider = ({ children }) => {
    const { auth } = useAuth();
    const [props, setProps] = useState({});

    useEffect(() => {
        const eventType = eventTypes.find(t => t.value === auth.eventType) || eventTypes.find(t => t.value === 'event_speaker');
        setProps(eventType.props);
    }, []);

    return (
        <EventTypeContext.Provider value={{ props, setProps }}>
            {children}
        </EventTypeContext.Provider>
    );
};
export default EventTypeContext;